module.exports = __webpack_public_path__ + "img/logo-yellow.adbe7f47.svg";